/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
    PersonHandleToJSONTyped,
} from './PersonHandle';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
    EventNameToJSONTyped,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventAuthenticationFailedV1
 */
export interface SDKEventAuthenticationFailedV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventAuthenticationFailedV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1
     */
    person_id?: string;
    /**
     * 
     * @type {Array<FactorMethod>}
     * @memberof SDKEventAuthenticationFailedV1
     */
    authenticated_methods?: Array<FactorMethod>;
    /**
     * 
     * @type {FactorMethod}
     * @memberof SDKEventAuthenticationFailedV1
     */
    failed_authn_method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1
     */
    failure_reason: string;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1
     */
    failure_detail?: string;
    /**
     * 
     * @type {PersonHandle}
     * @memberof SDKEventAuthenticationFailedV1
     */
    handle?: PersonHandle;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1
     */
    challenge_id?: string;
}



/**
 * Check if a given object implements the SDKEventAuthenticationFailedV1 interface.
 */
export function instanceOfSDKEventAuthenticationFailedV1(value: object): value is SDKEventAuthenticationFailedV1 {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('failed_authn_method' in value) || value['failed_authn_method'] === undefined) return false;
    if (!('failure_reason' in value) || value['failure_reason'] === undefined) return false;
    return true;
}

export function SDKEventAuthenticationFailedV1FromJSON(json: any): SDKEventAuthenticationFailedV1 {
    return SDKEventAuthenticationFailedV1FromJSONTyped(json, false);
}

export function SDKEventAuthenticationFailedV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventAuthenticationFailedV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'authenticated_methods': json['authenticated_methods'] == null ? undefined : ((json['authenticated_methods'] as Array<any>).map(FactorMethodFromJSON)),
        'failed_authn_method': FactorMethodFromJSON(json['failed_authn_method']),
        'failure_reason': json['failure_reason'],
        'failure_detail': json['failure_detail'] == null ? undefined : json['failure_detail'],
        'handle': json['handle'] == null ? undefined : PersonHandleFromJSON(json['handle']),
        'challenge_id': json['challenge_id'] == null ? undefined : json['challenge_id'],
    };
}

export function SDKEventAuthenticationFailedV1ToJSON(json: any): SDKEventAuthenticationFailedV1 {
    return SDKEventAuthenticationFailedV1ToJSONTyped(json, false);
}

export function SDKEventAuthenticationFailedV1ToJSONTyped(value?: SDKEventAuthenticationFailedV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_name': EventNameToJSON(value['event_name']),
        'person_id': value['person_id'],
        'authenticated_methods': value['authenticated_methods'] == null ? undefined : ((value['authenticated_methods'] as Array<any>).map(FactorMethodToJSON)),
        'failed_authn_method': FactorMethodToJSON(value['failed_authn_method']),
        'failure_reason': value['failure_reason'],
        'failure_detail': value['failure_detail'],
        'handle': PersonHandleToJSON(value['handle']),
        'challenge_id': value['challenge_id'],
    };
}

